function observeMutations(elementSelector, callback) {
  if (document.querySelectorAll(elementSelector).length == 0) {
    return;
  }
  var observer = new MutationObserver(callback);
  var config = { attributes: true, childList: true, characterData: false };
  observer.observe(document.querySelector(elementSelector), config);

  return observer;
}

function removeRouteShippingProduct() {
  const isProductPage = /product/.test(window.location.href);
  const product = document.querySelector(`.template-product .product-recommendations-pannel [href*='/products/shipping-insurance']`);

  if (!product || !isProductPage) {
    return;
  }

  product.closest(`.product`).classList.add('shipping-insurance-product');
  product.closest(`.product`).remove();

}
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(removeRouteShippingProduct, 100);
});
(function ($) {
  const shipppingProductId = 39485866573977;
  const $insuranceCheckbox = $('.shipping-insurance-checkbox');
  const returnStatus = (cart) => {
    const { items } = cart;
    let isInsuranceInCart = items.some(item => item.id === shipppingProductId);
    return {
      items,
      isInsuranceInCart
    }
  }
  const actionProduct = ({ quantity, id, action }) => {
    let URL = (action === 'add') ? '/cart/add.js' : '/cart/change.js';
    $.post(URL, {
      quantity,
      id,
      success: function () {
        setTimeout(utils.refreshCart, 150);
      }
    })
  }
  document.addEventListener('ajaxProduct:added', _.debounce(function (e) {

    theme.cart.getCart().then(cart => {
      const { items, isInsuranceInCart } = returnStatus(cart);
      if (!isInsuranceInCart && items.length > 0) {
        $insuranceCheckbox.prop('checked', true);
        actionProduct({ quantity: 1, id: shipppingProductId, action: 'add' });
      }
    })
  }, 250))

  document.addEventListener('cart:updated', _.debounce(function (e) {

    const { items, isInsuranceInCart } = returnStatus(e.detail.cart);

    if (!isInsuranceInCart) {
      $insuranceCheckbox.prop('checked', false);
    }
    if (isInsuranceInCart && $insuranceCheckbox.is(":checked") && items.length === 1) {
      $insuranceCheckbox.prop('checked', false);
      actionProduct({ quantity: 0, id: shipppingProductId, action: 'change' });
    }
  }, 250))
  function MovePaymentTermsAfterPrice() {
    $('.product-block--price').after($('shopify-payment-terms'));
  }

  function FooterAccordion() {
    $(".footer-accordion__title").click(function () {
      if ($(this).hasClass("hc-active")) {
        var newID = $(this).attr("data-id");
        $("#" + newID).slideUp();
        $(this).removeClass("hc-active");
      }
      else {
        var newID = $(this).attr("data-id");
        $("#" + newID).slideDown();
        $(this).addClass("hc-active");
        $(".footer-accordion__title").not($(this)).removeClass("hc-active");
        $(".footer-accordion__content").not($(".footer-accordion__content#" + newID)).slideUp();
      }
    });
  }
  function BundleCartItems() {
    $(document).on('click', '.remove-bundle-item', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var $btn = $(e.currentTarget);
      var bundle_id = $btn.data('bundle');
      var isCartPage = $('.template-cart').length !== 0;

      $.getJSON('/cart.js').then(function (cart) {
        var bundle_items = cart.items.filter(function (item) {
          return item.properties && item.properties.__bundle == bundle_id;
        });

        var confirm_remove = confirm('Are you sure, this will remove all items on this bundle?');
        if (confirm_remove) {
          var bundle_items_keys = bundle_items.map(function (item) {
            return item.key;
          });

          var updates = {};
          bundle_items_keys.forEach(function (key) {
            updates[key] = 0;
          });
          //console.log(updates);

          $.post('/cart/update.js', { updates: updates }, null, 'json')
            .then(function (response) {
              utils.refreshCart();
              if (isCartPage) {
                window.location.reload();
              }
            })
            .fail(function (error) {
              console.error(error);
            })
        }
      });
    });

    function updateCartItems(cart) {
      cart.items.forEach(function (item, index) {
        var bundle_id = item.properties.__bundle;
        var isBundle = bundle_id !== undefined;

        if (isBundle) {
          var $item = $('.cart__items .cart__item:eq(' + index + ')');
          $item.addClass('is-bundle');

          $item.find('.bundle-badge').remove();
          $item.find('.cart__product-name').before('<span class="bundle-badge">Bundle</span>');

          $item.find('.cart-item-qty').remove();

          $item.find('[data-cart-item-delete]').after('<button type="button" class="remove-bundle-item text-link" data-bundle="' + bundle_id + '">Remove Bundle</button>');
          $item.find('[data-cart-item-delete]').remove();
        }
      });
    }

    document.addEventListener('cart:updated', function (e) {
      var cart = e.detail.cart;
      updateCartItems(cart);
    });

    $.getJSON('/cart.js').then(updateCartItems);
  }

  function VariantChange() {
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail.variant;
      setTimeout(function () {
        $('.klaviyo-bis-trigger')[variant.available ? 'addClass' : 'removeClass']('hc-notify-hidden');
      }, 0);
    });
  }
  function ShippingInsurance() {

    theme.cart.getCart().then(cart => {
      const { items, isInsuranceInCart } = returnStatus(cart);

      if (isInsuranceInCart) {
        $insuranceCheckbox.prop('checked', true);
      }
      if (items.length === 0 && !isInsuranceInCart) {
        $insuranceCheckbox.prop('checked', false);
      }
    })
    $insuranceCheckbox.on('change', function () {
      if (!$(this).is(":checked")) {
        let quantity = $(`[data-id="${shipppingProductId}"]`).find('.js-qty__adjust--minus');
        quantity.click();
        return;
      }
      actionProduct({ quantity: 1, id: shipppingProductId, action: 'add' });
    })
  }
  $(document).ready(function () {

    MovePaymentTermsAfterPrice();
    FooterAccordion();

    ShippingInsurance();
    BundleCartItems();
    VariantChange();

  })
})(jQuery);
